export const typography = {
  fontFamily: 'Inter',
  headline: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 24,
    lineHeight: 29,
    letterSpacing: -0.2,
  },
  label: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 17,
    lineHeight: 22,
    letterSpacing: -0.4,
  },
  labelMedium: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 17,
    lineHeight: 22,
    letterSpacing: -0.2,
  },
  labelEmphasized: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 17,
    lineHeight: 22,
    letterSpacing: -0.1,
  },
  title: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: -0.3,
  },
  titleMedium: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: -0.2,
  },
  titleEmphasized: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: -0.2,
  },
  body1: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: -0.15,
  },
  body1Medium: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: -0.15,
  },
  body1Emphasized: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: -0.2,
  },
  body2: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 12,
    lineHeight: 17,
    letterSpacing: -0.2,
  },
  body2Medium: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 12,
    lineHeight: 17,
    letterSpacing: -0.2,
  },
  body2Emphasized: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 12,
    lineHeight: 17,
    letterSpacing: -0.2,
  },
  subtitle: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 9,
    lineHeight: 15,
    letterSpacing: -0.2,
  },
} as any
